import Modal from "../Modal";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ModalProps {
  isOpen: boolean
  setIsOpen: (arg0: boolean) => void
  fullName: string
  onSubmit: () => void
}

export default function DeleteUserModal({ isOpen, setIsOpen, fullName, onSubmit }: ModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="flex flex-col items-center text-center">
        <div className="size-16 bg-red-100 rounded-full flex items-center justify-center mb-4 text-red-600">
          <ExclamationTriangleIcon className="size-10" />
        </div>
        <h3 className="text-xl font-bold text-neutral-800 mb-2">Hapus User</h3>
        <p className="text-neutral-500 mb-8">
          Apakah Anda yakin ingin menghapus user <span className="font-bold text-neutral-800">"{fullName}"</span>? 
          Tindakan ini tidak dapat dibatalkan dan akses user tersebut akan segera dihentikan.
        </p>
      </div>
      <div className="flex gap-3 justify-center">
        <button
          className="px-6 py-2 text-neutral-600 font-medium rounded-lg hover:bg-neutral-100 transition-colors"
          onClick={() => setIsOpen(false)}
        >
          Batal
        </button>
        <button
          className="bg-red-600 text-white px-8 py-2 rounded-lg font-semibold hover:bg-red-700 active:scale-95 transition-all shadow-lg shadow-red-200"
          onClick={() => {
            onSubmit()
            setIsOpen(false)
          }}
        >
          Ya, Hapus User
        </button>
      </div>
    </Modal>
  )
}
